import { AGENCY_MARKETER_RECEIVED } from './AgencyMarketerReceived';

export default (previousState = {
  custom4:{
    agency_id: 0,
    margin: 0
  }
}, { type, payload }) => {
    if (type === AGENCY_MARKETER_RECEIVED) {
        return payload.data;
    }
    return previousState;
}



// WEBPACK FOOTER //
// ./src/agency/redux/agencymarketerReducer.js